import React from "react";
import { StyleSheet } from "react-native";
import { Box, TouchableBox } from "arkh";

type Props = React.PropsWithChildren<{
  onPress: () => void;
  selected: boolean;
  color: string;
}>;

export function Option(props: Props) {
  return (
    <TouchableBox onPress={props.onPress}>
      <Box
        style={styles.optionBorder}
        borderColor={props.selected ? "darkText" : "transparent"}
      >
        <Box style={[styles.option, { backgroundColor: props.color }]}>
          {props.children}
        </Box>
      </Box>
    </TouchableBox>
  );
}

const OPTION_SIZE = 64;

const styles = StyleSheet.create({
  optionBorder: {
    width: OPTION_SIZE,
    height: OPTION_SIZE,
    borderRadius: OPTION_SIZE,
    borderWidth: 4,
    alignItems: "center",
    justifyContent: "center",
  },
  option: {
    width: 50,
    height: 50,
    borderRadius: 25,
    alignItems: "center",
    justifyContent: "center",
  },
});
